<h2 mat-dialog-title>Új projekt létrehozása</h2>
<mat-dialog-content [formGroup]="form">
  <mat-form-field>
    <input matInput placeholder="Név" formControlName="name">
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="flex-buttons">
    <app-button [title]="'Mégsem'" [customColor]="'red'" (click)="close()"></app-button>
    <app-button *ngIf="!form.invalid" [title]="'Mentés'" [customColor]="'green'" (click)="save()"></app-button>
  </div>
</mat-dialog-actions>
